export enum TipoColaborador {
  NaoColaborador = 'NAO_COLABORADOR',
  Colaborador = 'COLABORADOR',
  Restrito = 'RESTRITO',
}

export enum FlagColaborador {
  NaoColaborador,
  Colaborador,
  Conselheiro,
}
